import React from 'react';
import ReactSwitch from 'react-switch';

import classNames from './switch.module.scss';
import * as models from '../../../utils/models';

const Switch: React.FC<models.SwitchProps> = ({
	checked,
	label,
	onChange,
	onColor = '#AB3C3C',
	offColor = '#DFE1E6',
	readOnly = false,
}) => {
	return (
		<label className={classNames.switch}>
			<ReactSwitch
				height={16}
				width={38}
				offColor={offColor}
				onColor={onColor}
				handleDiameter={16}
				onChange={onChange}
				checked={checked}
				readOnly={readOnly}
				className={classNames['switch-button']}
			/>
			<span>{label}</span>
		</label>
	);
};

export default Switch;
